/* @ngInject */
export default function PlaidFactory(HPConfig, $http, $q) {
    return {
        openPlaid,
        updateContractorLocationACH,
        createLinkToken,
        exchangeToken,
    };

    function openPlaid(linkToken) {
        return $q((resolve, reject) => {
            const plaidHandler = Plaid.create({
                token: linkToken,
                onLoad: () => {
                },
                onSuccess: (public_token, metadata) => {
                    //console.log("plaid onSuccess:");
                    //console.log("public_token: " + public_token);
                    //console.log("metadata" + JSON.stringify(metadata));

                    // Note: metadata already included public_token property
                    resolve(metadata);
                },
                onExit: (err, metadata) => {
                    if (err != null) {
                        reject(err);
                    } else {
                        resolve(metadata);
                    }
                },
                onEvent: function (eventName, metadata) {
                    //console.log("EV");
                    //console.log(eventName);
                    //console.log(JSON.stringify(metadata));
                },
            });

            plaidHandler.open();
        });
    }

    function updateContractorLocationACH(contractorId, publicToken, selectedAccountId) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/PlaidACH`,
            method: 'POST',
            data: {
                ContractorLocationId: contractorId,
                PublicToken: publicToken,
                SelectedAccountId: selectedAccountId,
            },
        });
    }

    function createLinkToken(contractorId) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Plaid/Link/Token/Create`,
            method: 'POST',
            data: {
                clientName: 'Finance of America',
                user: {
                    clientUserId: contractorId,
                },
                products: [
                    'auth',
                    'transactions',
                ],
            },
        }).then(response => response.data);
    }

    function exchangeToken(publicToken) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Plaid/Item/Public_Token/Exchange`,
            method: 'POST',
            data: {
                public_token: publicToken,
            },
        }).then(response => response.data);
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/financing/plaidFactory.js